<script>
/**
 * Actions Data component
 */
import EditAction from "./update-action";
import { authComputed, actionsMethods } from "@/state/helpers";
export default {
  props: ["actions", "busy", "loaderStatus"],
  components: {
    EditAction,
  },
  data() {
    return {
      action: null,
      actionsList: [],

      currentPage: 1,
      perPage: 6,
    };
  },
  computed: {
    ...authComputed,
    fieldsComputed() {
      if (this.loggedIn.user.role != 'USER' && this.loggedIn.user.role != 'OPERATOR') {
        return [
          { key: "name", sortable: false, label: this.$t("titles.actions.text"), class: "tdClass" },
          { key: "actions", sortable: false, label: this.$t("dataTable.tools.text"), class: "tdClass" },
        ];
      } else {
        return [{ key: "name", sortable: false, label: this.$t("titles.actions.text"), class: "tdClass" }];
      }
    },
  },
  mounted() {},
  methods: {
    ...actionsMethods,
    showModalEdit() {
      this.$bvModal.show("edit-action-modal");
    },
    hideModalEdit() {
      this.$bvModal.hide("edit-action-modal");
    },
    edit(action) {
      this.updateAction(action)
        .then((action) => {
          this.makeToast(
            "Update action",
            action.name + " has been updated",
            "success"
          );
        })
        .catch((error) => {
          this.makeToast("Update action", error, "danger");
        });
    },
    passAction(type, action) {
      if (type == "edit") {
        this.action = action;
        this.showModalEdit();
      } else if (type == "delete") {
        this.$swal
          .fire({
            title: this.$t('modals.askValidDelete.text'),
            text: this.$t('modals.cantRevert.text'),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: this.$t("buttons.validDelete.text"),
            cancelButtonText: this.$t("buttons.cancel.text"),
            showLoaderOnConfirm: true,
            preConfirm: () => {
              this.delAction(action.id)
                .then((response) => {
                  return response;
                })
                .catch((error) => {
                  this.$swal.showValidationMessage(`Request failed: ${error}`);
                });
            },
            allowOutsideClick: () => !this.$swal.isLoading(),
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.$swal.fire(
                "Deleted!",
                "The action has been deleted.",
                "success"
              );
            }
          })
          .catch((error) => {
            this.makeToast("Alert Error", error, "danger");
          });
      }
    },
    makeToast(title, msg, variant) {
      this.$bvToast.toast(msg, {
        title: title,
        variant: variant,
        solid: true,
      });
    },
    rowClicked(record) {
      //this.$router.push({name:'alert', params: { serial: record.serial }})
      console.log(record);
    },
  },
  watch: {
    actions(newVal) {
      this.actionsList = newVal;
    },
  },
};
</script>

<template>
  <div>
    <div
      class="table-responsive mb-3 bg-white rounded-lg"
      style="min-height: 350px"
    >
      <b-table
        class="mb-0"
        hover
        show-empty
        centred
        :busy="busy"
        :empty-text="$t('dataTable.noActions.text')"
        :current-page="currentPage"
        :per-page="perPage"
        :items="actionsList"
        :fields="fieldsComputed"
        v-bind:style="{ cursor: `pointer` }"
        stacked="sm"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <strong>{{$t('dataTable.loading.text')}}</strong>
          </div>
        </template>
        <template v-slot:cell(actions)="data">
          <div class="d-inline-flex align-items-center">
            <b-button
              type="button"
              class="mr-2"
              variant="light"
              @click="passAction('edit', data.item)"
              >Edit
            </b-button>
            <b-button
              type="button"
              variant="danger"
              @click="passAction('delete', data.item)"
              >Delete
            </b-button>
          </div>
        </template>
      </b-table>
      <EditAction v-bind:action="action" @editAction="edit" />
    </div>
    <div class="row">
      <div class="col-12">
        <div class="dataTables_paginate paging_simple_numbers float-right">
          <ul class="pagination pagination-rounded">
            <!-- pagination -->
            <b-pagination
              v-model="currentPage"
              :total-rows="actions.length"
              :per-page="perPage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.tdClass {
  text-align: center;
}
</style>